import {Spinner } from 'react-bootstrap'

const Logo = ({size=20, className=""}) => {
  return (
    <>
      <img className={`theme-dark-show logo-default h-${size}px w-${size}px ${className}`} src="/images/logos/white-logo-circle-mobile.png"/>
      <img className={`theme-light-show logo-default h-${size}px w-${size}px ${className}`} src="/images/logos/logo-circle-mobile.png"/>
    </>
  )
}

const SplashLogo = () => {
  return (
    <div className="d-flex flex-center w-100 h-100 flex-column">
      <Logo size={50}/>
      <Spinner animation='border' className="mt-5"/>
    </div>
  )
}

const getLogoAsString = (size=20) => {
  return `<span id="logo"><img className="theme-light-show logo-default w-${size}px h-${size}px" style="height: 100%; width: auto;" src="/images/logos/logo.svg"/>
        <img className="theme-dark-show logo-default w-${size}px h-${size}px" style="height: 100%; width: auto;" src="/images/logos/white-logo-mobile.png"/></span>`
} 
export {Logo, SplashLogo, getLogoAsString}
  